import { TopBar } from "./TopBar";

export function AuthLayout({ eyebrow, title, subtitle, children, testId }) {
  return (
    <div className="rmm-bg min-h-screen">
      <TopBar />
      <main className="mx-auto w-full max-w-md px-4 py-8 sm:px-6 sm:py-14">
        <div data-testid={testId} className="rmm-card rmm-rise p-6 sm:p-8">
          {eyebrow && <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C59B27]">{eyebrow}</p>}
          <h1 className="mt-2 font-display text-3xl font-bold tracking-tight text-[#4A000E] sm:text-4xl">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-[#8C6A6C]">{subtitle}</p>}
          <div className="gold-rule my-6" />
          {children}
        </div>
      </main>
    </div>
  );
}

export function ErrorAlert({ message, testId = "auth-error-message" }) {
  if (!message) return null;
  return (
    <div role="alert" data-testid={testId} className="rounded-lg border border-[#A31828]/30 bg-[#A31828]/5 px-3 py-2.5 text-sm text-[#A31828]">
      {message}
    </div>
  );
}
